import React, { useState } from "react";
import FilterChipDisplay from "../../../Filtering/FilterChipDisplay";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import TypeFiltersDialog from "./TypeFiltersDialog";


interface IClientFiltersProps {
    type: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function TypeFilters({ type, changeFilter }: IClientFiltersProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const text = `Type: ${type}`

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setDialogOpen(true)} />
            <TypeFiltersDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                currentType={type}
                changeFilter={changeFilter} />
        </>
    )
}